import { colors } from '../../colors';
var pagination = {
  activeColor: colors.petsuitesPurple,
  defaultColor: colors.graphite
};
export default pagination;